import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email } from 'vuelidate/lib/validators';
import { emailErrorMessagesMixin } from '~/mixins';
import { InternalServerError } from '~/abstractions/errors';
import { onlyEmail, noSpecialChars } from '~/validators';

export default {
    layout: 'login',
    mixins: [emailErrorMessagesMixin],
    fetch: function fetch(_ref) {
        var store = _ref.store;

        store.commit('dashboard/details/setToolbarTitle', 'Reestablecer contraseña');
    },
    data: function data() {
        return {
            sending: false,
            email: '',
            emailSended: false,
            sendingText: 'Enviar',
            errorMessage: null,
            isUserRegister: true
        };
    },

    validations: {
        email: {
            required: required,
            // email,
            noSpecialChars: noSpecialChars('noSpecialChars'),
            emailValidate: onlyEmail('emailValidate')
        }
    },
    methods: {
        onSubmit: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var timestamp, _ref3, existeCorreo, responseServer, _email, serverIp;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;


                                // servicio para verificar correo
                                timestamp = Date.now();
                                _context.next = 4;
                                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                                    transaccionId: timestamp,
                                    correo: this.email.toLowerCase()
                                });

                            case 4:
                                _ref3 = _context.sent;
                                existeCorreo = _ref3.existeCorreo;
                                responseServer = _ref3.responseServer;
                                _email = _ref3.email;
                                serverIp = _ref3.serverIp;

                                if (!(responseServer === 'Error')) {
                                    _context.next = 14;
                                    break;
                                }

                                this.$swal('Error', 'Error en el servicio. Vuelva a intentarlo mas tarde.', 'error');
                                this.sending = false;
                                _context.next = 38;
                                break;

                            case 14:
                                if (!existeCorreo) {
                                    _context.next = 36;
                                    break;
                                }

                                this.$v.$touch();

                                if (!this.$v.$invalid) {
                                    _context.next = 18;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 18:

                                this.sending = true;
                                this.sendingText = 'Enviando...';
                                this.errorMessage = null;

                                _context.prev = 21;
                                _context.next = 24;
                                return this.$store.dispatch('user/forgotPassword', {
                                    email: this.email
                                });

                            case 24:
                                this.emailSended = true;
                                this.sending = false;

                                _context.next = 33;
                                break;

                            case 28:
                                _context.prev = 28;
                                _context.t0 = _context['catch'](21);

                                if (_context.t0 instanceof InternalServerError) this.isUserRegister = false;
                                this.sending = false;
                                this.$controlMessage(_context.t0);

                            case 33:

                                this.sendingText = 'Enviar';
                                _context.next = 38;
                                break;

                            case 36:
                                this.$swal('Aviso', 'No existe el correo ' + this.email + ', ingresar uno correcto.', 'warning');
                                this.sending = false;

                            case 38:
                                _context.next = 44;
                                break;

                            case 40:
                                _context.prev = 40;
                                _context.t1 = _context['catch'](0);

                                this.$swal('Aviso', 'El correo ingresado tiene formato incorrecto.', 'warning');
                                this.sending = false;

                            case 44:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 40], [21, 28]]);
            }));

            function onSubmit() {
                return _ref2.apply(this, arguments);
            }

            return onSubmit;
        }(),
        reset: function reset() {
            this.$v.$reset();
            this.email = '';
            this.emailSended = false;
        }
    },
    watch: {
        email: function email() {
            this.isUserRegister = true;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/forgot-password.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/forgot-password.vue
// module chunks = 16